// <costiera-delivery-date>: rewrites the server-rendered "Get it by" date in the shopper's own time zone, so a
// cached page or a different time zone never shows yesterday's date. Pure functions first (unit-tested with `npm test`).

export function deliveryDate(from, days) {
  const date = new Date(from.getTime());
  date.setDate(date.getDate() + days);
  return date;
}

export function formatDeliveryDate(date, locale) {
  return new Intl.DateTimeFormat(locale, { weekday: 'long', month: 'short', day: 'numeric' }).format(date);
}

if (typeof customElements !== 'undefined' && !customElements.get('costiera-delivery-date')) {
  customElements.define(
    'costiera-delivery-date',
    class CostieraDeliveryDate extends HTMLElement {
      connectedCallback() {
        const days = Number(this.dataset.days);
        const target = this.querySelector('[data-delivery-date]');
        if (!target || !Number.isFinite(days)) return;
        const locale = document.documentElement.lang || 'en';
        target.textContent = formatDeliveryDate(deliveryDate(new Date(), days), locale);
      }
    }
  );
}
